import components from './src/components/pc';
export default {
    components
};
